import { Button } from "../components";
import CountDownTimer from "../components/CountDownTimer";
import { status, vanarChainId } from "./constants";

export const handleButtons = (
  isConfirmDisabled,
  setIsAmountConfirmed,
  chainId,
  switchChainId,
  isSwitching,
  callBack,
  isAmountConfirmed,
  btnloading,
  currentStatus,
  isUnstake,
  isClaim
) => {

  if (chainId !== Number(vanarChainId) && !isSwitching) {
    return (
      <button
        onClick={() => switchChainId(Number(vanarChainId))}
        type="button"
        className={`cursor-pointer inline-flex justify-center items-center bg-transparent text-xsm lg:text-sm leading-[24px] font-semibold rounded-full outline-0 -tracking-[0.42] duration-300 primary-gradient w-full p-[15px] md:p-[21px] capitalize`}
      >
        Switch Network
      </button>
    );
  } else if (btnloading || isSwitching) {
    // (btnloading && currentStatus === status.PENDING)
    return (
      <button
        disabled
        type="button"
        className={`opacity-50 cursor-not-allowed inline-flex justify-center items-center bg-transparent text-xsm lg:text-sm leading-[24px] font-semibold rounded-full outline-0 -tracking-[0.42] duration-300 primary-gradient w-full p-[15px] md:p-[21px] capitalize`}
      >
        Processing
      </button>
    );
  } else if (isAmountConfirmed) {
    return (
      <button
      id="stake"
        disabled={isConfirmDisabled}
        onClick={callBack}
        type="button"
        className={`${
          isConfirmDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }inline-flex justify-center items-center bg-transparent text-xsm lg:text-sm leading-[24px] font-semibold rounded-full outline-0 -tracking-[0.42] duration-300 primary-gradient w-full p-[15px] md:p-[21px] capitalize`}
      >
        {isUnstake ? "unstake" : isClaim ? "claim" : "stake"}
      </button>
    );
  } else {
    return (
      <button
        id="confirm"
        disabled={isConfirmDisabled}
        onClick={() => setIsAmountConfirmed(true)}
        type="button"
        className={`${
          isConfirmDisabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
        }inline-flex justify-center items-center bg-transparent text-xsm lg:text-sm leading-[24px] font-semibold rounded-full outline-0 -tracking-[0.42] duration-300 primary-gradient w-full p-[15px] md:p-[21px] capitalize`}
      >
        Confirm
      </button>
    );
  }
};

export const handleConnectSignMessage = (
  loading,
  selectedWallet,
  isSwitching,
  connector,
  isNavBtn,
  disconnectCalled,
  isMetaMaskInstalled,
  isMobile
) => {
  if (
    selectedWallet === connector?.name &&
    !isNavBtn &&
    !disconnectCalled &&
    isMetaMaskInstalled &&
    !isMobile
  ) {
    if (loading) {
      return "Connecting...";
    } else if (isSwitching) {
      return "Switching Network...";
    } else {
      return "Signing Message...";
    }
  } else {
    if (isNavBtn) {
      return `Connect Wallet`;
    } else {
      return `Continue with ${connector?.name}`;
    }
  }
};

export const handleTrxHistoryBtn = (
  method,
  date,
  userDelegators,
  validatorAddres,
  trxStatus,
  value,
  claimed,
  unstakeTrx
) => {
  const coolDownPeriod = userDelegators?.find(
    (e) => e.id === validatorAddres
  )?.cooldown_period;

  if (trxStatus === "completed") {
    if (method === "stake") {
      return (
        <Button
          className="primary-gradient py-3 px-[14px] leading-none !opacity-50 !cursor-not-allowed min-w-[110px]"
          disabled={true}
        >
          Staked
        </Button>
      );
    } else if (method === "claim stake" || method === "claim reward") {
      return (
        <Button
          id="claimed"
          className="primary-gradient py-3 px-[14px] leading-none !opacity-50 !cursor-not-allowed min-w-[110px]"
          disabled={true}
        >
          Claimed
        </Button>
      );
    } else if (method === "unstake") {
      return (
        <CountDownTimer
          unstakeTrx={unstakeTrx}
          startTime={date}
          coolDownPeriod={coolDownPeriod}
          value={value}
          validatorContractaddress={validatorAddres}
          claimed={claimed}
        />
      );
    }
  } else if (trxStatus === "pending") {
    return (
      <Button
        className="py-3 px-[14px] leading-none bg-[#D9AA03]/[0.08] text-[#D9AA03] !text-sm !font-medium !cursor-not-allowed min-w-[110px]"
        disabled={true}
      >
        Pending
      </Button>
    );
  } else {
    return (
      <Button
        className="py-3 px-[14px] leading-none bg-[#FD7979]/[0.10] text-[#FD7979] !text-sm !font-medium !cursor-not-allowed"
        disabled={true}
      >
        Failed
      </Button>
    );
  }
};
